export default __webpack_public_path__ + "static/media/intro-new.42914e08.webp";